module.exports = __webpack_public_path__ + "img/license.6966c51a.jpg";